import * as React from 'react';
import { useState } from 'react';
import './greenCheckBox.scss';

interface Props {
  onCheck: any;
  defaultValue: boolean;
  text?: string;
  rounded?: boolean;
}

const GreenCheckBox = ({ onCheck, defaultValue, text, rounded = false }: Props): JSX.Element => {
  const [checked, setChecked] = useState<boolean>(defaultValue);
  const onClick = (e: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(e.target.checked);
    onCheck(e.target.checked);
  };

  React.useEffect(() => {
    setChecked(defaultValue);
  }, [defaultValue]);

  return (
    <div className={rounded ? 'greenCheckCircleContainer' : 'greenCheckBoxContainer'}>
      <>
        <label htmlFor="greenCheck" className="container">
          <input id="greenCheck" type="checkbox" checked={checked} onChange={onClick} />
          <span className="checkmark"></span>
          <div className="greencheckboxText">{text}</div>
        </label>
      </>
    </div>
  );
};

export { GreenCheckBox };
